import { Switch as MantineSwitch } from '@mantine/core';
import type { SwitchProps as MantineSwitchProps } from '@mantine/core';

import type { LockedProps } from '../types';

type SwitchProps = Omit<MantineSwitchProps, LockedProps>;

export const Switch = (props: SwitchProps) => {
  return <MantineSwitch {...props} />;
};
